import { render, staticRenderFns } from "./ResourcesId.vue?vue&type=template&id=83edda32"
import script from "./ResourcesId.vue?vue&type=script&lang=js"
export * from "./ResourcesId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports